<template>
  <modal v-bind="modalParams" @modalClick="cancel">
    <transition name="popup">
      <div v-show="isShow" class="action-sheet">
        <div class="action-sheet-header">
          <div class="title" v-show="title">
            <p>{{ title }}</p>
          </div>
          <div
            class="content-item"
            v-for="(item, i) in actions"
            :key="i"
            @click="actionClick(item)">
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="action-sheet-footer">
          <div class="title" @click="cancel">
            <p>{{ cancelText }}</p>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import Modal from '../Modal'
export default {
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    },
    cancelText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: false,
      isShow: false,
      modalParams: {
        showModal: false,
        lockScroll: true
      }
    }
  },
  watch: {
    value (newVal) {
      this.modalParams.showModal = newVal
      this.isShow = newVal
    }
  },
  destroyed () {
    this.isShow = false
  },
  methods: {
    handleAction (action) {
      this.value = false
      this.callback(action)
    },
    actionClick (item) {
      this.isShow = false
      setTimeout(() => {
        this.modalParams.showModal = false
        this.handleAction({
          action: 'success',
          ...item
        })
      }, 300)
    },
    cancel () {
      this.isShow = false
      setTimeout(() => {
        this.modalParams.showModal = false
        this.handleAction({
          action: 'cancel'
        })
      }, 300)
    },
    closeMask () {
      this.isShow = false
      this.value = false
      this.modalParams.showModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
.action-sheet {
  position: absolute;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  .action-sheet-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    border-radius: 13px;
    overflow: hidden;
    background-color: $color-bg-white;
    .title {
      box-sizing: border-box;
      padding: 13px;
      p {
        color: $color-title;
        font-size: $small-font-size;
        text-align: center;
      }
    }
    .content-item {
      @include border-top;

      box-sizing: border-box;
      padding: 16px;
      p {
        color: $color-primary;
        font-size: $h5-font-size;
        text-align: center;
      }
    }
  }
  .action-sheet-footer {
    display: flex;
    flex-direction: column;
    border-radius: 13px;
    overflow: hidden;
    background-color: $color-bg-white;
    .title {
      box-sizing: border-box;
      padding: 15px;
      p {
        @include font-Regular;

        color: $color-primary;
        font-size: $h5-font-size;
        text-align: center;
      }
    }
  }
}
.popup-enter-active {
  animation: slide-in 0.3s ease;
}
.popup-leave-active {
  animation: slide-out 0.3s ease;
}
@keyframes slide-in {
  0% {
    margin-bottom: -100%;
  }
  100% {
    margin-bottom: 0;
  }
}
@keyframes slide-out {
  0% {
    margin-bottom: 0;
  }
  100% {
    margin-bottom: -100%;
  }
}
</style>
